import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { bannerGradient } from '../data/bannerColors';
import { uploadsAPI } from '../services/api';
import { useT } from '../services/i18n';
import { localizeBanner } from '../services/catalogI18n';

const BannerSlide = ({ banner: raw, className = '', compact = false, testId }) => {
  const { t, lang } = useT();
  const banner = localizeBanner(raw, lang);
  const hasImage = !!banner.image;
  const isExternal = /^https?:\/\//.test(banner.link || '');
  const label = banner.button_label || t('banner.discover');

  const cta = banner.link ? (
    isExternal ? (
      <a href={banner.link} target="_blank" rel="noreferrer" data-testid={testId ? `${testId}-cta` : undefined}
         className="inline-flex items-center gap-2 bg-white text-gray-900 font-semibold px-5 py-2.5 rounded-full hover:bg-orange-50 transition-colors mt-4 text-sm">
        {label} <ArrowRight size={16} />
      </a>
    ) : (
      <Link to={banner.link} data-testid={testId ? `${testId}-cta` : undefined}
            className="inline-flex items-center gap-2 bg-white text-gray-900 font-semibold px-5 py-2.5 rounded-full hover:bg-orange-50 transition-colors mt-4 text-sm">
        {label} <ArrowRight size={16} />
      </Link>
    )
  ) : null;

  return (
    <div
      data-testid={testId}
      className={`relative w-full flex-shrink-0 bg-gradient-to-r ${bannerGradient(banner.color)} ${compact ? 'p-4 min-h-[110px]' : 'p-6 sm:p-8 md:p-12 min-h-[180px] sm:min-h-[200px]'} flex items-center overflow-hidden ${className}`}
    >
      {hasImage && (
        <>
          <img src={uploadsAPI.resolveUrl(banner.image)} alt="" className="no-placeholder absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-black/20" />
        </>
      )}
      <div className="relative text-white">
        <h2 className={`${compact ? 'text-lg' : 'text-2xl sm:text-3xl md:text-4xl'} font-bold mb-1 drop-shadow break-words`}>{banner.title}</h2>
        {banner.subtitle && <p className={`${compact ? 'text-sm' : 'text-lg sm:text-xl md:text-2xl'} mb-1`}>{banner.subtitle}</p>}
        {banner.description && <p className={`${compact ? 'text-xs' : 'text-base sm:text-lg'} opacity-90`}>{banner.description}</p>}
        {!compact && cta}
      </div>
    </div>
  );
};

export default BannerSlide;
